import app from 'flarum/forum/app';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import { extend as mithrilExtend } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import TagsPage from 'ext:flarum/tags/forum/components/TagsPage';
export { default as extend } from './extend';

// Lazy loaded, so referred to by module path rather than imported.
const CategoriesPage = 'ext:fof/categories/forum/components/CategoriesPage';
function pruneIndexNav(items, func) {
  const isTagsPageVisible = app.forum.attribute('categories.keepTagsNav');
  const isCustomTagsHidden = app.current.matches(CategoriesPage) || app.current.matches(TagsPage);
  for (const key of Object.keys(items.toObject())) {
    if (func(key)) {
      if (key == 'tags') {
        if (!isTagsPageVisible) {
          items.remove(key);
        }
      } else {
        if (isCustomTagsHidden) {
          items.remove(key);
        }
      }
    }
  }
}
app.initializers.add('fof-categories', () => {
  mithrilExtend(IndexSidebar.prototype, 'navItems', function (items) {
    items.add('categories', m(LinkButton, {
      icon: "fas fa-th-list",
      href: app.route('categories')
    }, app.translator.trans('fof-categories.forum.index.categories_link')), -9.5);
    if (items.has('moreTags')) {
      items.setContent('moreTags', m(LinkButton, {
        href: app.route('categories')
      }, app.translator.trans('flarum-tags.forum.index.more_link')));
    }
    pruneIndexNav(items, item => item.startsWith('tag'));
  });
  app.prefetch.add('fof-categories.categoriesPage', () => import(/* webpackChunkName: 'forum/components/CategoriesPage', webpackMode: 'lazy-once' */ './components/CategoriesPage'));
  if ('fof-forum-widgets-core' in flarum.extensions) {
    app.widgets?.addPage(CategoriesPage);
  }
});flarum.reg.addChunkModule('85', '924', 'fof-categories', 'forum/components/CategoriesPage');
flarum.reg.addChunkModule('85', '924', 'fof-categories', 'forum/components/Category');
flarum.reg.addChunkModule('85', '924', 'fof-categories', 'forum/components/StatWidget');
flarum.reg.addChunkModule('85', '924', 'fof-categories', 'forum/components/LastDiscussionWidget');